'use client';

import React from 'react';
import NextErrorComponent from 'next/error';

// Replaces the pages router `_error.tsx` and `500.tsx`. The app router uses a
// single `error.tsx` client boundary for runtime errors; `not-found.tsx`
// handles 404s separately.
export default function GlobalError({
  reset,
}: {
  error: Error & {digest?: string};
  reset: () => void;
}) {
  // Opinionated: do not record an exception in Sentry for client errors here;
  // matches the previous `pages/500.tsx` behavior.
  return (
    <>
      <NextErrorComponent statusCode={500} />
      <button type="button" onClick={reset} hidden>
        Try again
      </button>
    </>
  );
}
